import React, { ReactElement } from 'react';

import { Flex, RichContent, Section, Typography } from 'components';

import { useModules } from 'features/modules';
import { DownloadsBox } from 'features/downloads';
import { useParams } from 'react-router-dom';

const ModulesDescription = (): ReactElement => {
  const { moduleDetails } = useModules();
  const { productSlug, moduleUuid } = useParams();

  let moduleHat = 'Detalhes';
  let moduleTitle = 'O que você aprenderá nesse módulo';

  if (productSlug === 'clube-do-livro') {
    moduleTitle = 'O que você aprenderá nesse livro';
  } else if (productSlug === 'fraternidade-melver' && moduleUuid === 'abadd168-2029-422d-a938-d151726cf12f') {
    moduleTitle = 'Evolução contínua na roda da vida';
  }

  return (
    <Section
      py={{ m: 40, d: 90 }}
      flexWrap={{ m: 'wrap', d: 'nowrap' }}
      alignItems="flex-start"
      justifyContent={{ d: 'space-between' }}
      style={{ gap: 40 }}
    >
      <Flex flexDirection="column">
        <Typography type="type3" upper>
          {moduleHat}
        </Typography>

        <Typography type="type8" fontWeight="bold" mt={2}>
          {moduleTitle}
        </Typography>

        <Typography type="type2" mt={3} lineHeight="1.5">
          <RichContent>{moduleDetails.description}</RichContent>
        </Typography>
      </Flex>

      {Boolean(moduleDetails.downloads.length) && (
        <Flex maxWidth={{ m: '100%', d: 360 }} flexShrink={0}>
          <DownloadsBox downloads={moduleDetails.downloads} />
        </Flex>
      )}
    </Section>
  );
};

export default ModulesDescription;
